module.exports = __webpack_public_path__ + "img/Alert.f02de80d.png";